import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useLanguage } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InsightDetail() {
  const { slug } = useParams();
  const { lang, t } = useLanguage();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/insights/${slug}`);
        if (mounted) setItem(res.data);
      } catch (e) {
        if (mounted) setError("not_found");
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [slug]);

  const formatDate = (iso) => {
    try {
      const d = new Date(iso);
      return d.toLocaleDateString(lang === "en" ? "en-GB" : "es-ES", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "";
    }
  };

  return (
    <div className="min-h-screen bg-white text-ink" data-testid="page-insight">
      <Navbar />
      <main className="pt-32 md:pt-40 pb-24">
        <article className="max-w-3xl mx-auto px-6 md:px-12">
          <Link
            to="/#insights"
            data-testid="insight-back"
            className="inline-flex items-center gap-2 text-[12px] tracking-[0.22em] uppercase text-ink-soft hover:text-ink mb-12 transition-colors"
          >
            <ArrowLeft size={14} />
            {t.insights.back}
          </Link>

          {loading && (
            <p className="text-sm text-ink-soft" data-testid="insight-loading">
              …
            </p>
          )}

          {error === "not_found" && !loading && (
            <div data-testid="insight-not-found">
              <h1 className="font-serif-display text-4xl text-ink">404</h1>
              <p className="mt-4 text-ink-soft">
                {lang === "en"
                  ? "Note not found."
                  : "No se ha encontrado la nota."}
              </p>
            </div>
          )}

          {item && (
            <div>
              <p className="eyebrow" data-testid="insight-category">
                {lang === "en" ? item.category_en : item.category_es}
              </p>
              <h1
                className="mt-4 font-serif-display font-light text-4xl md:text-6xl leading-[1.05] tracking-tight text-ink"
                data-testid="insight-title"
              >
                {lang === "en" ? item.title_en : item.title_es}
              </h1>
              <p className="mt-6 text-sm text-muted-foreground" data-testid="insight-date">
                {formatDate(item.published_at)} · Ivan Bautista
              </p>
              <div className="rule-line my-10" />
              <div
                className="prose prose-lg max-w-none font-serif-display text-xl md:text-2xl leading-relaxed text-ink-soft whitespace-pre-line"
                data-testid="insight-body"
              >
                {lang === "en" ? item.body_en : item.body_es}
              </div>
            </div>
          )}
        </article>
      </main>
      <Footer />
    </div>
  );
}
